// Operations data - All operations across all engines
// This file aggregates operations from all engines in the system

import type { OperationSchema } from '../engines';
import { ProspectorEngine } from '../engines/ProspectorEngine';
import { KnowledgeEngine } from '../engines/KnowledgeEngine';

export type OperationWithEngine = OperationSchema & {
  engineId: string;
  engineName: string;
  enginePurpose: string;
  // Future: interfaceRules, requiredInputs, optionalInputs
};

// Collect operations from all engines
function collectAllOperations(): OperationWithEngine[] {
  const operations: OperationWithEngine[] = [];

  // Prospector Engine operations
  const prospectorEngine = new ProspectorEngine();
  const prospectorInfo = prospectorEngine.getInfo();
  prospectorInfo.operations.forEach(op => {
    operations.push({
      ...op,
      engineId: prospectorInfo.id,
      engineName: prospectorInfo.name,
      enginePurpose: prospectorInfo.purpose
    });
  });

  // Knowledge Engine operations
  const knowledgeEngine = new KnowledgeEngine();
  const knowledgeInfo = knowledgeEngine.getInfo();
  knowledgeInfo.operations.forEach(op => {
    operations.push({
      ...op,
      engineId: knowledgeInfo.id,
      engineName: knowledgeInfo.name,
      enginePurpose: knowledgeInfo.purpose
    });
  });

  // TODO: Add operations from other engines as they're implemented
  // - Canon Engine
  // - Authoring Engine
  // - Studio Engine
  // - Assembly Engine
  // - Publishing Engine
  // - Media Engine
  // - Education Engine
  // - Analytics Engine
  // - Orchestration Engine

  return operations;
}

export const allOperations = collectAllOperations();

// Helper to get operations by engine (empty string returns all)
export function getOperationsByEngine(engineId: string): OperationWithEngine[] {
  if (engineId === '') {
    return allOperations;
  }
  return allOperations.filter(op => op.engineId === engineId);
}

// Helper to get all unique engines
export function getAllEngines(): Array<{ id: string; name: string; purpose: string }> {
  const engines = new Map<string, { id: string; name: string; purpose: string }>();
  allOperations.forEach(op => {
    if (!engines.has(op.engineId)) {
      engines.set(op.engineId, {
        id: op.engineId,
        name: op.engineName,
        purpose: op.enginePurpose
      });
    }
  });
  return Array.from(engines.values());
}

